if (window.location.href.includes("detalle-importacion")) {
    
    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };
    const tableBody = document.querySelector("#DetalleImpo tbody");

    // Mover la función fuera del bloque if
    const actualizarTabla = (signal, { esRefrescoSilencioso = false } = {}) => {
        const getIdImpo = new URLSearchParams(window.location.search).get("id-impo");
        const filtroMerc = document.getElementById("filtroMercancia").value;
        const filtroGrupoMerc = document.getElementById("filtroGrupoMerc").value;
        const filtroProv = document.getElementById("filtroProv").value;

        if (!esRefrescoSilencioso) {
            window.mostrarFilasEsqueleto(tableBody, 9);
        }

        const params = new URLSearchParams({
            "id-impo": getIdImpo,
            filtroMercancia: filtroMerc,
            filtroGrupMerc: filtroGrupoMerc,
            filtroProv,
        });
        const url = `/api/impo/detalle?${params.toString()}`;

        return fetch(url, { ...requestOptions, cache: "no-store", signal, sinCargando: true })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                // Limpiar la tabla antes de llenarla nuevamente
                tableBody.innerHTML = "";
                const jsonData = result;
                const imp = jsonData.result;

                imp.forEach(item => {
                    const row = document.createElement("tr");
                    row.innerHTML = `
                        <td>${item.codigo}</td>
                        <td class="td-d">${item.descripcion}</td>
                        <td class="td-d">${item.grupo_mercancia}</td>
                        <td>${item.nombre_proveedor}</td>
                        <td>${item.comercial}</td>
                        <td class="td-num">${Number(item.cantidad).toLocaleString()}</td>
                        <td class="td-num">${Number(item.reserva).toLocaleString()}</td>
                        <td class="td-num">${Number(item.disponible).toLocaleString()}</td>
                        <td>
                            <div class="cont-acciones">
                                <button class="btn-tabla btn-reservar" type="button" data-id="${item.id_mercancia}" title="Reservar" aria-label="Reservar ${item.descripcion ?? ''}">
                                    <img class="svg-acciones" src="/public/build/img/icons/reservar-mas.svg" alt="">
                                </button>
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(row);
                });

                if (imp == 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data"); // Asignar la clase al <tr>
                    row.innerHTML = `
                        <td colspan="8">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(row);
                }
            });
    };

    const actualizador = window.crearActualizadorApi(actualizarTabla);

    // Esperar una pausa corta antes de consultar con los nuevos filtros.
    document.getElementById("filtroMercancia").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroGrupoMerc").addEventListener("change", actualizador.alCambiarFiltro);
    document.getElementById("filtroProv").addEventListener("change", actualizador.alCambiarFiltro);

    // Limpiar filtros
    const btnLimpiarFiltros = document.getElementById("btnLimpiarFiltros");
    if (btnLimpiarFiltros) {
        btnLimpiarFiltros.addEventListener("click", () => {
            document.getElementById("filtroMercancia").value = "";
            document.getElementById("filtroGrupoMerc").value = "0";
            document.getElementById("filtroProv").value = "0";
            actualizador.alCambiarFiltro();
        });
    }

    // Carga inicial inmediata y siguientes actualizaciones cada 5 minutos.
    actualizador.iniciar();
}
